<template>
  <div
    class="Bar10Charts"
    ref="loading-box"
    :loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    :class="[{ link: isOpenLink && !isEditMode ? true : false }, getStyle('title')]"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
  >
    <DateDropDownSelect
      v-if="value.isShowRightDropDownBox"
      :selectData="selectData"
      :selectApi="selectApi"
      @selectChange="selectChange"
    >
    </DateDropDownSelect>
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import DateDropDownSelect from '@/components/common/DateDropDownSelect/DateDropDownSelect.vue';
import { getFilterValue } from '../../../../utils/tool';
import { mapState } from 'vuex';
import { request } from '../../../../common/request';
export default {
  name: 'Bar10Charts',
  components: { DateDropDownSelect },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      loading: true, // 加载对象
      noData: false,
      selectData: [],
      params: {}, // 请求参数
      paramsCopy: {},
      value: {
        isShowRightDropDownBox: false,
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.setStyle();
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    selectChange(e) {
      console.log(e, 'selectChange');
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
        // this.asyncLocalDatatest();
      } else {
        this.params = getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      this.loading = true;
      if (
        !ParamData ||
        Object.keys(ParamData).length === 0 ||
        !ParamData.source ||
        ParamData.source.length === 0
      ) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let cUnit = {};
      let seriesList = [];
      let dropDownNumberData = [];
      let backgroundColor = '';
      let unit = '';
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        dropDownNumberData = ParamData?.dropDownNumberData;
      }
      if (this.Configuration.propertyData.chartsUnit?.value) {
        cUnit = this.Configuration.propertyData.chartsUnit.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      let that = this;
      function dealSelectData() {
        let selectData = [];
        let yearData = [];
        let monthData = [];

        if (dropDownNumberData) {
          dropDownNumberData.forEach(Years => {
            let child = [];
            let choicekey = [];
            // 子 一月 二月... 判断
            if (Years[3]) {
              Years[3].forEach(item_D => {
                //  判断 是否有出现 展示第3个下拉框的标识
                if (item_D[2] != undefined && item_D[2] != null) {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                    // 需要出现 日 时
                    third: item_D[2],
                  });
                } else {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                  });
                }
              });
            }

            if (Years[4]) {
              choicekey.push(Years[4]);
            }

            // 父 不为空
            if (Years[0] != undefined && child.length != 0 && Years[4]) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
                key: choicekey,
              });
            } else if (Years[0] != undefined && child.length != 0) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
              });
            } else if (Years[0] != undefined) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
              });
            }
          });
        }
        that.selectData = selectData;
      }

      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }
      let series = [];
      let xAxis_data = [];
      let yAxis_data = [];

      function DealData() {
        seriesList.forEach((s, index) => {
          let cate = {
            name: s,
            data: [], // 模拟数据，和设计稿高度匹配
            type: 'pictorialBar',
            symbol: 'path://M0,10 L10,0 L90,0 L100,10 Z', // 梯形路径
            symbolSize: ['6%', '100%'], // 宽度和高度
            symbolPosition: 'center',
            label: {
              show: true,
              position: 'top',

              color: '#fff',
            },
            itemStyle: {
              // 优化渐变：让颜色过渡更自然
              color: new Echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 垂直渐变（上到下）
                [
                  { offset: 1, color: chartColor[index] }, //  底部颜色
                  { offset: 0.5, color: chartColor[index] }, // 中间过渡色
                  { offset: 0, color: chartColor[index].replace('1)', '0.2)') }, //顶部颜色
                ],
              ),
              borderRadius: [0, 0, 0, 0], // 顶部圆角，模拟设计稿
            },
          };
          // 数据处理
          source.forEach(item => {
            xAxis_data.push(item.x); // 确保 xAxis_data 有数据
            if (s === item.s) {
              yAxis_data.push(item.y); // 确保 yAxis_data 有数据
              cate.data.push(item.y);
            }
          });
          let topline = {
            //顶部的横杠
            type: 'pictorialBar',
            symbol: 'rect',
            symbolSize: ['10%', 2],
            symbolOffset: [0, -2],
            symbolPosition: 'end',
            data: yAxis_data,
            itemStyle: {
              color: chartColor[index],
            },
          };
          series.push(cate, topline);
        });
        xAxis_data = [...new Set(xAxis_data)];
      }
      DealData();
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'none',
            label: {
              show: false,
              backgroundColor: '#6a7985',
            },
            lineStyle: {
              color: '#21a5a5',
              width: 1,
            },
          },
          formatter: function (params) {
            if (!params || params.length === 0) {
              return ''; // 如果 params 为空，返回空字符串
            }
            return (
              '<div>' + params[0].name + '<br>' + params[0].marker + '<span>' + params[0].value + '</div>'
            );
          },
        },
        grid: {
          ...grid,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: xAxis_data, // 模拟单数据场景，x 轴文案和数据对应
          // show: true, // 显示 x 轴（如需隐藏可设为 false）
          axisLine: {
            lineStyle: { color: fontStyle.xAxisColor },
          },
          axisLabel: {
            color: fontStyle.xAxisColor, //更改坐标轴文字颜色
            fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
            textStyle: {
              fontFamily: 'Microsoft YaHei',
            },
            align: 'center', // 文字居中显示
          },
        },
        yAxis: {
          type: 'value',
          name: unit,
          nameTextStyle: {
            color: '#fff',
            nameLocation: 'start',
            padding: [cUnit.top, cUnit.right, cUnit.bottom, cUnit.left],
            // 单位
            fontSize: '12px',
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white',
            },
          },
          axisLabel: {
            color: fontStyle.yAxisColor, //更改坐标轴文字颜色
            fontSize: fontStyle.xAxisSize,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255,0.3)',
            },
          },
        },
        series: series,
        animation: true,
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除定时器
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};

          eval(filter_text);

          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '瓶型柱状图',
    componentName: 'Bar10Charts',
    componentOverViewImg: './img/charts/BarCharts/Bar10Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '朝阳区',
                i: 1,
              },
              {
                s: '人数',
                y: '67',
                x: '东城区',
                i: 2,
              },
              {
                s: '人数',
                y: '55',
                x: '海淀区',
                i: 3,
              },
              {
                s: '人数',
                y: '34',
                x: '通州区',
                i: 4,
              },
              {
                s: '人数',
                y: '12',
                x: '西城区',
                i: 5,
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      chartsUnit: {
        lable: '单位定位',
        propertyComponentName: 'ChartsUnitConfiger',
        value: {
          left: '10',
          right: '0',
          bottom: '0',
          top: '0',
        },
      },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Bar10Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .DateDropDownSelect {
    position: absolute;
    top: 2px;
    right: 4%;
    z-index: 10;
  }
  .no-data {
    width: 100%;
    height: 100%;
    /* // background: #000; */
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #a9a9a9;
  }
}
.V11Style {
  :deep().dis-block .drop-down-select:nth-child(1) .el-input__inner {
    width: 74px !important;
  }
  :deep().drop-down-select .el-input__inner {
    border: 1px solid #c63a36 !important;
    color: #fff !important;
  }
  .DateDropDownSelect {
    right: 0 !important;
  }
  :deep().el-icon-arrow-up:before {
    color: #fff !important;
  }
}

// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}
.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
